import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Typography,
  Divider,
} from '@material-ui/core';
import { useFormik } from 'formik';
import { sefazParamsAPI } from 'services/apiRest';
import { actions as toastrActions } from 'react-redux-toastr';
import { useDispatch } from 'react-redux';

function ModalParametrosSefaz({ open, onClose }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({
    CTE: { ambiente: 'homologacao', serie: 1, numero: 1 },
    MDFE: { ambiente: 'homologacao', serie: 1, numero: 1 },
  });

  useEffect(() => {
    if (open) {
      carregarParams();
    }
  }, [open]);

  const carregarParams = async () => {
    try {
      setLoading(true);
      const dados = await sefazParamsAPI.listar();
      
      const paramsObj = {};
      dados.forEach((param) => {
        paramsObj[param.tipo] = {
          ambiente: param.ambiente,
          serie: param.serie,
          numero: param.numero,
        };
      });

      // Se não tiver CTE ou MDFE, usar valores padrão
      if (!paramsObj.CTE) {
        paramsObj.CTE = { ambiente: 'homologacao', serie: 1, numero: 1 };
      }
      if (!paramsObj.MDFE) {
        paramsObj.MDFE = { ambiente: 'homologacao', serie: 1, numero: 1 };
      }

      setParams(paramsObj);
    } catch (error) {
      console.error('Erro ao carregar parâmetros:', error);
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'Erro ao carregar parâmetros SEFAZ',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cte_ambiente: params.CTE?.ambiente || 'homologacao',
      cte_serie: params.CTE?.serie || 1,
      cte_numero: params.CTE?.numero || 1,
      mdfe_ambiente: params.MDFE?.ambiente || 'homologacao',
      mdfe_serie: params.MDFE?.serie || 1,
      mdfe_numero: params.MDFE?.numero || 1,
    },
    onSubmit: async (values) => {
      try {
        setLoading(true);

        // Atualizar CT-e
        await sefazParamsAPI.atualizar('CTE', {
          ambiente: values.cte_ambiente,
          serie: parseInt(values.cte_serie),
          numero: parseInt(values.cte_numero),
        });

        // Atualizar MDF-e
        await sefazParamsAPI.atualizar('MDFE', {
          ambiente: values.mdfe_ambiente,
          serie: parseInt(values.mdfe_serie),
          numero: parseInt(values.mdfe_numero),
        });

        dispatch(
          toastrActions.add({
            type: 'success',
            title: 'Sucesso',
            message: 'Parâmetros SEFAZ atualizados com sucesso!',
          })
        );

        onClose();
      } catch (error) {
        console.error('Erro ao atualizar parâmetros:', error);
        dispatch(
          toastrActions.add({
            type: 'error',
            title: 'Erro',
            message: error.message || 'Erro ao atualizar parâmetros SEFAZ',
          })
        );
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>Parâmetros SEFAZ</DialogTitle>
        <DialogContent dividers>
          <Box>
            {/* CT-e */}
            <Typography variant="h6" style={{ marginBottom: '16px', marginTop: '8px' }}>
              CT-e (Conhecimento de Transporte Eletrônico)
            </Typography>

            <FormControl fullWidth margin="normal">
              <InputLabel>Ambiente</InputLabel>
              <Select
                name="cte_ambiente"
                value={formik.values.cte_ambiente}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value="homologacao">Homologação</MenuItem>
                <MenuItem value="producao">Produção</MenuItem>
              </Select>
            </FormControl>

            <TextField
              fullWidth
              margin="normal"
              label="Série"
              name="cte_serie"
              type="number"
              value={formik.values.cte_serie}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ min: 1 }}
            />

            <TextField
              fullWidth
              margin="normal"
              label="Número Sequencial"
              name="cte_numero"
              type="number"
              value={formik.values.cte_numero}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ min: 1 }}
              helperText="Este número será incrementado automaticamente a cada emissão"
            />

            <Divider style={{ margin: '24px 0' }} />

            {/* MDF-e */}
            <Typography variant="h6" style={{ marginBottom: '16px' }}>
              MDF-e (Manifesto de Documentos Fiscais Eletrônico)
            </Typography>

            <FormControl fullWidth margin="normal">
              <InputLabel>Ambiente</InputLabel>
              <Select
                name="mdfe_ambiente"
                value={formik.values.mdfe_ambiente}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value="homologacao">Homologação</MenuItem>
                <MenuItem value="producao">Produção</MenuItem>
              </Select>
            </FormControl>

            <TextField
              fullWidth
              margin="normal"
              label="Série"
              name="mdfe_serie"
              type="number"
              value={formik.values.mdfe_serie}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ min: 1 }}
            />

            <TextField
              fullWidth
              margin="normal"
              label="Número Sequencial"
              name="mdfe_numero"
              type="number"
              value={formik.values.mdfe_numero}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputProps={{ min: 1 }}
              helperText="Este número será incrementado automaticamente a cada emissão"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button type="submit" color="primary" variant="contained" disabled={loading}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default ModalParametrosSefaz;

